export * from './bewertungs-anlasss-list.component';
export * from './bewertungs-anlasss-list.component.module';